/**
 * Horizontal clip only — do not set overflowY here (avoids a second scrollport).
 */
export const OVERFLOW_X_CLIP_SX = {
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  overflowX: "clip",
  overflowY: "visible",
};

/** Centered hero/footer glow — never wider than the viewport. */
export const CENTERED_GLOW_SX = {
  left: "50%",
  transform: "translateX(-50%)",
  width: "min(1400px, 100%)",
  maxWidth: "100%",
};
